export const TOOL_TYPE_LABELS = {
  ClayEffectiveFrictionAngle: 'Plasticity Index - Effective Friction Angle',
  Consolidation: 'Settlement (Shallow Foundations - Consolidation)',
  CvLLUsNavy: 'Liquid Limit - Coefficient of Consolidation (US Navy 1982)',
  Hansen: 'Bearing Capacity (Shallow Foundations - Hansen)',
  LayeredSoil: 'Average c and phi for Layered Soils',
  Liquefaction: 'Soil Liquefaction (SPT-based)',
  MohrCircle: 'Interactive Mohr Circle (Stress Transformation)',
  Meyerhof: 'Bearing Capacity (Shallow Foundations - Meyerhof)',
  Pilerockbc: 'Bearing Capacity (Pile Foundations in Rock - AASHTO 2002)',
  Pilerocksettle: 'Settlement (Pile Foundations in Rock - AASHTO 2002)',
  Terzaghi: 'Bearing Capacity (Shallow Foundations - Terzaghi)',
  UscsClassifier: 'USCS Soil Classification (ASTM D2487)',
  Vs30SiteClassEc8: 'Vs30 and Site Class (EC8)',
  WeightVolumeRelationships: 'Weight-Volume Relationships',
  Sptcorrection: 'SPT Corrections (N60, (N1)60)',
  Stroud: 'cu-mv and SPT-PI Relationships (Stroud 1974)',
  StressIncrease: 'Vertical Stress Increase (60 deg and 1H:2V)',
  Priebe: 'Stone Columns (Priebe Vibro Replacement)',
  SlopeStability: 'Slope Stability',
};

export const getToolTypeLabel = (toolKey) => TOOL_TYPE_LABELS[toolKey] || toolKey || '';
